import { render, staticRenderFns } from "./StudentProfile.vue?vue&type=template&id=1a6f248e"
import script from "../../../controllers/custom/student/student-profile.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/student/student-profile.js?vue&type=script&lang=js&external"
import style0 from "./StudentProfile.vue?vue&type=style&index=0&id=1a6f248e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports